export const ButtonSoldOut = () => {
	return <button className='sold-out'>Sold Out</button>
}
